import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthorArticlesClient"] */ "/workspace/src/components/author-articles-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/workspace/src/components/ui/separator.tsx");
